export default function () {
  let getCustomSignalDataSMA,
    customSignalDataSMA,
    getCustomSignalDataRSI,
    customSignalDataRSI,
    getCustomSignalDataMACD,
    customSignalDataMACD,
    getCustomSignalDataEMA,
    customSignalDataEMA,
    getCustomSignalDataSuperTrend,
    customSignalDataSuperTrend,
    getCustomSignalDataDI,
    customSignalDataDI,
    getCustomSignalDataPSAR,
    customSignalDataPSAR,
    saveModelSubmited = 0;

  return {
    getCustomSignalDataSMA,
    customSignalDataSMA,
    getCustomSignalDataRSI,
    customSignalDataRSI,
    getCustomSignalDataMACD,
    customSignalDataMACD,
    getCustomSignalDataEMA,
    customSignalDataEMA,
    getCustomSignalDataSuperTrend,
    customSignalDataSuperTrend,
    getCustomSignalDataDI,
    customSignalDataDI,
    getCustomSignalDataPSAR,
    customSignalDataPSAR,
    saveModelSubmited
  };
}
